import { Injectable } from '@angular/core';

@Injectable()
export class CommonService {
    constructor() {
    }

    range(input: any, min: number, max: number): any { // @Pipe({name: 'range'}) 와 동일 (range.pipe.ts)
        for (let i = min; i <= max; i++) {
            input.push(i);
        }
        return input;
    } // init: function(){

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + s4();
    }

}
